export default __webpack_public_path__ + "static/media/head10.0f062913.svg";